export { default } from './BasePillTypeAhead';
